import React,{ useContext} from "react";
import HeaderStyle from "./HeaderStyle.module.css";
//import react router
import { Link ,useNavigate} from "react-router-dom";
//material ui
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
//import context
import {CartContext} from '../../context/CartContextProvider'
import {AuthContext} from '../../context/AuthContextProvider'
//import clearStorage
import {clearStorage} from '../../core/storage/storage'
//start coding





function Header() {
  //contexts
  const authContext= useContext(AuthContext)
  const {state}=useContext(CartContext)

  //menu hamberger material ui
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  //end material
  const logOut=()=>{
    authContext.logOut()
    clearStorage("token");
  }
  return (
    <div className={HeaderStyle.header}>
    
        
        <Container maxWidth="xl">
        
          <Toolbar disableGutters >
         
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 5, ml: 5, display: { xs: "none", md: "flex" } }}
            >
             {authContext.isAuth ?  <p className={HeaderStyle.accant}>
                <Link to="/">
                  
                <span onClick={logOut} className={HeaderStyle.span}>خروج</span>
                  <PowerSettingsNewIcon />
                </Link>
              </p>:  <p className={HeaderStyle.accant}>
                <Link to="/Login">
                  
                <span className={HeaderStyle.span}>حساب کاربری</span>
                  <AccountCircleSharpIcon />
                </Link>
              </p>}
            </Typography>
           
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }} >
           
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              

              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
                
              >
                <Typography  textAlign="center" mr={2} ml={2}>
                <p
                    className={HeaderStyle.nav}
                   
                  >
                   <Link to="/"> خانه</Link>
                  </p>
                  
              
                </Typography>
                <Typography  textAlign="center" mr={2} ml={2}>
                <p
                    className={HeaderStyle.nav}
                    
                  >
                    ‎<Link to="/">‌دوره ‌ها</Link>
                  </p>
              
                </Typography> <Typography  textAlign="center" mr={2} ml={2}>
                <p
                    className={HeaderStyle.nav}
                    
                  >
                    <Link to="https://t.me/mhplny" mr={2} ml={2}>تماس باما</Link>
                    
                  </p>
              
                </Typography> <Typography  textAlign="center" mr={2} ml={2}>
                <p
                    className={HeaderStyle.nav}
                    
                  >
                    <Link to="/about">درباره ‌ما</Link>
                    
                  </p>
              
                </Typography>
              </Menu>
            </Box>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}
            >
               {authContext.isAuth ?  <p className={HeaderStyle.accant}>
                <Link to="/">
                  
                <span onClick={logOut} className={HeaderStyle.span}>خروج</span>
                  <PowerSettingsNewIcon />
                </Link>
              </p>:  <p className={HeaderStyle.accant}>
                <Link to="/Login">
                  
                <span className={HeaderStyle.span}>حساب کاربری</span>
                  <AccountCircleSharpIcon />
                </Link>
              </p>}
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              
                <Button
                 
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  <span
                    className={HeaderStyle.nav}
                   
                  >
                   <Link to="/"> خانه</Link>
                  </span>
               
                </Button>
                
                <Button
                 
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  <span
                    className={HeaderStyle.nav}
                    
                  >
                    ‎<Link to="/">‌دوره ‌ها</Link>
                  </span>
               
                </Button>
                <Button
                 
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  <span
                    className={HeaderStyle.nav}
                    
                  >
                    <a href="https://t.me/mhplny">تماس باما</a>
                    
                  </span>
               
                </Button>
                <Button
                 
                  sx={{ my: 2, color: "white", display: "block" }}
                >
                  <span
                    className={HeaderStyle.nav}
                    
                  >
                    <Link to="/about">درباره ‌ما</Link>
                    
                  </span>
               
                </Button>
                
            </Box> 
         <Link to="/cart">   <span className={HeaderStyle.Logo}><ShoppingCartIcon/><span  className={HeaderStyle.itemsCounter}>{state.itemsCounter}</span></span></Link>
          </Toolbar>
          

        </Container>

    </div>
  );
}

export default Header;
